"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useAdaptiveCardsContext;

var _react = require("react");

var _AdaptiveCardsContext = _interopRequireDefault(require("../../AdaptiveCardsContext"));

function useAdaptiveCardsContext() {
  var context = (0, _react.useContext)(_AdaptiveCardsContext.default);

  if (!context) {
    throw new Error('This hook can only be used on component that is decendants of <ComposerWithAdaptiveCards>');
  }

  return context;
}